
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
.contact-card {

    border-radius: 0.75rem;

    border-width: 1px;

    border-style: solid;

    border-color: var(--neutral-gray-4);

    padding: 2rem;

    padding-bottom: 1rem
}

.contact-card-headline, .contact-card-sub-headline, .contact-card-top-content, .contact-card-bottom-content {

    font-family: var(--bh-ff-body);

    font-weight: var(--fw-normal);

    color: var(--bh-neutral-black)
}

.contact-card-bottom-section {

    margin-top: 2rem;

    border-width: 0px;

    border-top-width: 1px;

    border-style: solid;

    border-color: var(--neutral-gray-4);

    padding-top: 2rem
}

::slotted([slot='contact-card-top-content']) {

    font-size: var(--bh-fs-body-01);

    line-height: var(--bh-lh-body-01);

    letter-spacing: var(--bh-ls-body-01);

    line-height: 1.5rem
}

.contact-card-sub-headline {

    padding-bottom: 0.75rem;

    font-size: var(--bh-fs-heading-03);

    line-height: var(--bh-lh-heading-03);

    letter-spacing: var(--bh-ls-heading-03);

    font-weight: var(--fw-bold)
}

@media (min-width: 1024px) {

    .contact-card-sub-headline {

        padding-top: 0.75rem;

        padding-bottom: 0.75rem
    }
}

.contact-card-headline {

    padding-bottom: 0.75rem
}

::slotted([slot='contact-card-headline']) {

    font-size: var(--bh-fs-heading-05);

    line-height: var(--bh-lh-heading-05);

    letter-spacing: var(--bh-ls-heading-05);

    font-weight: var(--fw-light)
}
`;